module.exports = __webpack_public_path__ + "img/banner.a7046b1d.png";